module.exports = __webpack_public_path__ + "img/hvh-home.8626e433.png";